import { Theme } from '@routific/hive';
import { IColor } from '../types/IColor'; 

const getBackgroundColor = (loading: boolean, disabled: boolean, color: IColor | undefined) => {
  if (loading) {
    return color?.hexLight; 
  } else if (disabled) {
    return color?.hexLighter; 
  } else if (color) {
    return color?.hex; 
  } else {
    // handle color being undefined
    return `${Theme.Colors.gray0}`;
  }
};

export default getBackgroundColor;
